import type { ReactNode } from 'react';
import React from 'react';
import { Link } from 'gatsby';

import { PAGE_URLS } from 'consts/pageUrls';
import { EVENTS } from 'consts/metricsTrackingEvents';
import { trackEvent } from 'utils/metricsTracking';

import {
  SectionContainer,
  ContentContainer,
  TitleContainer,
  Title,
  Subtitle,
  OuterStepsContainer,
  InnerStepsContainer,
  OrangeBlock,
  DisplayNumber,
  StepsBlock,
  Step,
  StepNumber,
  mobileCta,
  desktopCta,
} from './HowItWorks.style';

export interface HowItWorksProps {
  title: string;
  subtitle?: ReactNode;
  ctaText: string;
  media: React.ReactNode;
  steps: Array<string>;
}

const moduleName = 'howItWorks';

export const HowItWorks = ({
  title,
  subtitle,
  ctaText,
  media,
  steps,
}: HowItWorksProps) => {
  const handleClick = () => {
    trackEvent(EVENTS.linkClicked, { module: moduleName });
  };

  return (
    <SectionContainer data-module={moduleName}>
      <ContentContainer>
        <TitleContainer>
          <div>
            <Title>{title}</Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </div>

          <Link
            to={PAGE_URLS.howItWorks}
            css={desktopCta}
            onClick={handleClick}
          >
            {ctaText}
          </Link>
        </TitleContainer>

        <OuterStepsContainer>
          {media}
          <InnerStepsContainer>
            <OrangeBlock>
              <DisplayNumber>{steps.length}</DisplayNumber> steps
            </OrangeBlock>
            <StepsBlock>
              {steps.map((step, index) => {
                return (
                  <Step key={index}>
                    <StepNumber>{index + 1}</StepNumber>
                    <div>{step}</div>
                  </Step>
                );
              })}
            </StepsBlock>
          </InnerStepsContainer>
        </OuterStepsContainer>

        <Link to={PAGE_URLS.howItWorks} css={mobileCta} onClick={handleClick}>
          {ctaText}
        </Link>
      </ContentContainer>
    </SectionContainer>
  );
};
